var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-row",
        [
          _c("b-col", { staticClass: "px-0", attrs: { cols: "6" } }, [
            _c("label", { style: _vm.isReadonly ? "" : _vm.selectorStyles }, [
              _c("div", { staticClass: "circle rounded-circle" }, [
                !_vm.avatar
                  ? _c("img", {
                      staticClass: "default-avatar",
                      attrs: {
                        height: _vm.avatarHeight,
                        width: _vm.avatarWidth,
                        alt: _vm.$t("message.avatar.default"),
                        src: require("ti-icons/SVG/user.svg")
                      }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.avatar
                  ? _c("img", {
                      staticClass: "rounded-circle",
                      attrs: {
                        height: _vm.avatarHeight,
                        width: _vm.avatarWidth,
                        alt: _vm.$t("message.avatar.default"),
                        src: _vm.avatarSrc
                      }
                    })
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c("input", {
                attrs: {
                  type: "file",
                  hidden: "",
                  accept: "image/*",
                  disabled: _vm.isReadonly
                },
                on: { change: _vm.onFileChanged }
              })
            ]),
            _vm._v(" "),
            !_vm.isReadonly
              ? _c(
                  "label",
                  {
                    staticClass: "text-center mt-3",
                    style: _vm.isReadonly ? "" : _vm.selectorStyles
                  },
                  [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.$t("message.avatar.maxFileDimensions")) +
                        "\n        "
                    ),
                    _c("br"),
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          _vm.$t("message.avatar.maxFileDimensionsValue", {
                            height: _vm.maxHeight,
                            width: _vm.maxWidth
                          })
                        ) +
                        "\n        "
                    ),
                    _c("input", {
                      attrs: {
                        type: "file",
                        hidden: "",
                        accept: "image/*",
                        disabled: _vm.isReadonly
                      },
                      on: { change: _vm.onFileChanged }
                    })
                  ]
                )
              : _vm._e()
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4a8aa18f", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4a8aa18f","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/account/AvatarForm.vue
// module id = +1Nm
// module chunks = 1